import React, { useContext, Fragment } from 'react';
import { useTheme } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { VisitContext } from '../Context/contexts/VisitContext';
import { Timer } from '../Timer/Timer';
import { VisitHeader, MinVisitTitle, StyledActionIcon } from '../../components';
import { MINIMIZE_VISIT_DIALOG } from '../Context/constants';
import defaults from '../../translations/en.json';
import './visit.css';

export const MinimizedVisit = () => {
  const { minimizeVisitDialog, dispatchVisit } = useContext(VisitContext);
  const { palette } = useTheme() as any;

  const onMaximizeVisit = () =>
    dispatchVisit({
      type: MINIMIZE_VISIT_DIALOG,
      payload: false,
    });

  return minimizeVisitDialog ? (
    <Fragment>
      <div className="visit-max">
        <VisitHeader onClick={onMaximizeVisit}>
          <MinVisitTitle>{defaults.openedVisitMin}</MinVisitTitle>
          {/* <Timer minimize /> */}
        </VisitHeader>
      </div>
      <div className="visit-min">
        <StyledActionIcon
          htmlColor={palette.error.light}
          Icon={AddCircleIcon}
          onClick={onMaximizeVisit}
        />
      </div>
    </Fragment>
  ) : null;
};

export default MinimizedVisit;
